import { useEffect, useState, useRef } from "react";
import {
  signInWithPopup,
  signOut,
  browserSessionPersistence,
  setPersistence,
} from "firebase/auth";
import { firebaseAuth, provider } from "../firebase-config";
import { useStateValue } from "../context/StateProvider";
import { actionType } from "../context/reducer";
import { saveUserToFirestore, getUserFromFirestore } from "../utils/FirebaseFunction";
import { useNavigate } from "react-router-dom";
import AudioPlayer from "./Audioplayer";
import { toast } from "react-toastify";  // No need to import ToastContainer here anymore

function LoginForm({ buttonClass }) {
  const [{ user, userIdhasAccess }, dispatch] = useStateValue();
  const [isLoggedin, setIsLoggedin] = useState(false);
  const navigate = useNavigate();

  const audioRef = useRef(null); // Audio referansı

  useEffect(() => {
    setIsLoggedin(user);
  }, [user]);

  useEffect(() => {
    if (user) {
      // Kullanıcı giriş yaptıysa ve /user sayfasına yönlendirdiysek müziği çal
      if (audioRef.current) {
        audioRef.current.play().catch((error) => {
          console.error("Müzik çalma hatası:", error);
        });
      }
    } else {
      if (audioRef.current) {
        audioRef.current.pause();
      }
    }
  }, [user]); // user değiştiğinde müziği çal
  

  const loginlogout = async () => {

    if (!user) {
      try {
        await setPersistence(firebaseAuth, browserSessionPersistence);
        const result = await signInWithPopup(firebaseAuth, provider);
        const providerData = result.user.providerData[0];

        const userUid = firebaseAuth.currentUser?.uid;
        // console.log("userUid : ",userUid)

        // `userIdhasAccess` kontrolü
        if (!userIdhasAccess.includes(providerData.uid)) {
          await signOut(firebaseAuth); // Kullanıcıyı çıkış yaptır
          toast.error("Yetkiniz yok. Sistemden çıkış yapıldı.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
          });
          return; // İşlemi burada sonlandır
        }

        // Kullanıcı Firestore'da var mı kontrol et
        const firestoreUser = await getUserFromFirestore(providerData.uid);

        if (firestoreUser) {
          dispatch({
            type: actionType.SET_USER,
            user: firestoreUser,
          });
        } else {
          // Firestore'da yoksa kaydet
          await saveUserToFirestore(providerData);
          dispatch({
            type: actionType.SET_USER,
            user: providerData,
          });
        }

        // Admin sayfasına yönlendir
        navigate("/admin");
      } catch (error) {
        console.error("Giriş işlemi sırasında hata oluştu:", error);
        toast.error("Bir hata oluştu. Lütfen tekrar deneyin.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
        });
      }
    } else {
      try {
        await signOut(firebaseAuth);
        dispatch({
          type: actionType.SET_USER,
          user: null,
        });

        toast.success("Başarıyla çıkış yaptınız. Görüşmek üzere!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
        });

        navigate("/");

      } catch (error) {
        console.error("Çıkış işlemi sırasında hata oluştu:", error);
        toast.error("Çıkış sırasında bir hata oluştu.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
        });
      }
    }





  };
  

  return (
    <>
      <AudioPlayer ref={audioRef} />

<button
  onClick={loginlogout}
  className={` ${!isLoggedin ? 'px-4 py-2' : 'px-2 py-1 text-sm'}  border-2 bg-greenTwo text-white hover:bg-greenOne border-gray-400 rounded flex items-center transition-colors duration-200 `}
>
  {!isLoggedin && (
    <img
      src="/images/google.svg"
      alt="Google logo"
      className="w-6 h-6 mr-2"
    />
  )}
  {isLoggedin ? "Çıkış Yap" : "Giriş Yap"}
</button>


    </>
  );
}

export default LoginForm;
